import ClubSalesListOfferingConfig from '../../dto/ClubSalesListOfferingConfig.js';
import Error from '../../model/Error.js';
import axios from 'axios';

export default class ClubSalesListOfferingConfigRepository {
    static findByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/sales-list/offering-config`)
                .then(response => resolve(ClubSalesListOfferingConfig.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)))
        });
    }

    static update(clubId, ClubSalesListOfferingConfig) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/sales-list/offering-config`, ClubSalesListOfferingConfig.serialize())
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
